import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import {
  applicationFetchTableData,
  applicationClearStateList,
  applicationDelete,
} from 'reducers/application/reducer'
import * as ROUTE from 'constants/appRouting'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import DateColumn from 'types/table/DateColumn'
import Sort from 'lib/psfs/Sort'
import ActiveColumn from 'types/table/ActiveColumn'
import messages from './translate'

class ApplicationList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.applicationFetchTableData
    this.deleteEntity = props.applicationDelete
    this.clearReducerState = props.applicationClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.applicationList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createButton),
      link: ROUTE.APPLICATION_CREATE,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteApplication),
      message: formatMessage(messages.deleteApplicationMessage),
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('description', formatMessage(messages.description), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('url', formatMessage(messages.url), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new ActiveColumn('active', formatMessage(messages.active), {
        sorting: true,
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.editApplication), row => {
        history.push(UrlHelper.create(ROUTE.APPLICATION_EDIT, { id: row.id }))
      }),
    )
    actions.add(
      new Action('delete', formatMessage(messages.deleteApplication), row => {
        this.onOpenConfirmDialog({ entityId: row.id, psfs: this.psfs })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['application', 'tableData']),
  }),
  {
    applicationFetchTableData,
    applicationClearStateList,
    applicationDelete,
  },
)(injectIntl(ApplicationList))
